import { render, staticRenderFns } from "./recommend-card.vue?vue&type=template&id=2322baf2&scoped=true"
import script from "./recommend-card.vue?vue&type=script&lang=js"
export * from "./recommend-card.vue?vue&type=script&lang=js"
import style0 from "./recommend-card.vue?vue&type=style&index=0&id=2322baf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322baf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2322baf2')) {
      api.createRecord('2322baf2', component.options)
    } else {
      api.reload('2322baf2', component.options)
    }
    module.hot.accept("./recommend-card.vue?vue&type=template&id=2322baf2&scoped=true", function () {
      api.rerender('2322baf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/recommend-card.vue"
export default component.exports